import HeaderAdmin from "./ManageUser/HeaderAdmin";
import MenuAdmin from "./Menu";

const HomeAdmin = () => {
  return (
    <div>
      <HeaderAdmin />
      <MenuAdmin />
    </div>
  );
};

export default HomeAdmin;
